<div class="page-title">
  <div [innerHTML]="'Documents.First.Identity.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Documents.First.Identity.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>
<app-identity-document
  (selectedDocumentChange)="onIdentityDocumentSelect($event)"
  *ngIf="this.identityDocuments"
  [(backDocument)]="user.proofIdentetyBackDocument"
  [(frontDocument)]="user.proofIdentetyDocument"
  [documents]="identityDocuments"
  [remove]="removeDocument.bind(this)"
  [submitted]="submitted"
  [update]="updateDocument.bind(this)"
  [upload]="uploadDocument.bind(this)"
>
</app-identity-document>

<div class="page-title">
  <div [innerHTML]="'Documents.First.Address.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Documents.First.Address.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>
<app-address-document
  (selectedDocumentChange)="onAddressDocumentSelect($event)"
  *ngIf="this.addressDocuments"
  [(additionalDocument)]="user.proofAddressAdditionalDocument"
  [(backDocument)]="user.proofAddressBackDocument"
  [(frontDocument)]="user.proofAddressDocument"
  [documents]="addressDocuments"
  [remove]="removeDocument.bind(this)"
  [submitted]="submitted"
  [update]="updateDocument.bind(this)"
  [upload]="uploadDocument.bind(this)"
>
</app-address-document>
